import React from 'react';
import cx from 'classnames';
import Button from '../../Buttons/Button';
import { useTranslation } from 'react-i18next';
import './PanoControls.scss';

const PanoControls = ({ mediaType, tourData, togglePanoControls }) => {
  const closeModal = () => togglePanoControls(false);
  const { t } = useTranslation();
  const controlsPopupClasses = cx({
    'tour-buttons': tourData.buttons.length > 0,
  });

  return (
    <section
      id="pano-controls-popup"
      className={`pano-controls-popup__wrapper ${controlsPopupClasses}`}
      data-cy="pano-controls-popup"
    >
      <div className="pano-controls-popup__close-btn-wrapper">
        <Button
          title={t(`publicTour.panoControls.closeButtonTitle`)}
          onClick={closeModal}
          className="popup-close-btn"
          data-cy="pano-controls-popup__close-btn"
        >
          <i className="material-icons" aria-hidden="true">
            close
          </i>
        </Button>
      </div>
      <div className="pano-controls-popup__announcement">
        <h3 className="pano-controls-popup__heading-3">
          {t(`publicTour.panoControls.${mediaType}.title`)}
        </h3>
        <p className="pano-ctonrols-popup__paragraph">
          {t(`publicTour.panoControls.instructions`)}
        </p>
      </div>
      <div className="pano-controls-popup__arrow-keys">
        <div className="pano-controls-popup__keyboard-up"></div>
        <div className="pano-controls-popup__keyboard-right"></div>
        <div className="pano-controls-popup__keyboard-down"></div>
        <div className="pano-controls-popup__keyboard-left"></div>
      </div>
      <div className="pano-controls-popup__zoom-keys">
        <div aria-hidden="true" className="pano-controls-popup__zoom-in"></div>
        <div className="pano-controls-popup__zoom-out"></div>
      </div>
    </section>
  );
};

export default PanoControls;
